/** The categories of the 3D library and their words
 *  (`backend/assetlib/categories.py`, docs/DECISIONS.md 2026-10-07). */

/** What an object is filed under, in the order a list prints them. */
export const OBJECT_CATEGORIES = [
  "electronics",
  "packaging",
  "furniture",
  "decor",
  "plants",
  "lighting",
  "food",
  "stage",
  "office",
  "tools",
  "kitchen",
  "garden-outdoor",
  "sport-leisure",
  "cosmetics",
  "containers",
  "signage",
  "vehicles",
] as const;

/** What a surface is filed under. */
export const SURFACE_CATEGORIES = [
  "surface-wood",
  "surface-metal",
  "surface-plastic",
  "surface-stone",
  "surface-fabric",
  "surface-glass",
  "surface-paper",
  "surface-ground",
  "surface-brick-tile",
] as const;

const WORDS: Record<string, string> = {
  electronics: "Electronics",
  packaging: "Packaging",
  furniture: "Furniture",
  decor: "Decor",
  plants: "Plants",
  lighting: "Lighting",
  food: "Food",
  stage: "Stage",
  office: "Office",
  tools: "Tools",
  kitchen: "Kitchen",
  "garden-outdoor": "Garden and outdoor",
  "sport-leisure": "Sport and leisure",
  cosmetics: "Cosmetics",
  containers: "Containers",
  signage: "Signs and displays",
  vehicles: "Vehicles",
  "surface-wood": "Wood",
  "surface-metal": "Metal",
  "surface-plastic": "Plastic",
  "surface-stone": "Stone",
  "surface-fabric": "Fabric",
  "surface-glass": "Glass",
  "surface-paper": "Paper",
  "surface-ground": "Ground",
  "surface-brick-tile": "Brick and tile",
  artwork: "Artwork",
};

/** A category's word: "Garden and outdoor" for `garden-outdoor`. An unknown
 *  value is shown as it is, with a capital. */
export function categoryWord(id: string): string {
  return (
    WORDS[id] ?? id.charAt(0).toUpperCase() + id.slice(1).replace(/-/g, " ")
  );
}

/** Whether `id` is a surface's category (the card's fact line is its word). */
export function isSurfaceCategory(id: string): boolean {
  return (SURFACE_CATEGORIES as readonly string[]).includes(id);
}
